import { Dialog}from '@mui/material';
import { LEVELNAME } from '../../utils/constants';
import { useState } from 'react';
import { ButtonStyled, CapitalizeWord, ChipStyled, ContentStyled, DescriptionContent, IconStar, IconStarOutline, PopupTitle, WrapperActions, WrapperStars } from './CreateQuizPopup.styled';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/authContext';


export const CreateQuizPopup = ({ isOpenPopup, onClosePopup, infoQuiz }) => {
    const [isCopied, setIsCopied] = useState(false);
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    const { category, quantity, level, timer, idQuiz, idFastQuiz } = infoQuiz;

    const pathNavigate = location.state?.pathNavigate ? location.state.pathNavigate : idFastQuiz? "/dashboard?tab=classroom" : "/dashboard?tab=quiz";


    const handleCopy = () => {
            navigator.clipboard.writeText(`${import.meta.env.VITE_URL_FRONTEND}/${idFastQuiz? `fastquiz/${idFastQuiz}`:`custom/${idQuiz}`}`).then(() => {
            setIsCopied(true);
        });
    };

    
    return (
        <>            
        <Dialog open={isOpenPopup}>

            <PopupTitle>
                Il tuo quiz è pronto!                
            </PopupTitle>
                
            <DescriptionContent>Sarà disponibile per <b>15 giorni</b>, poi verrà eliminato. Il suo nome sarà ispirato a un famoso matematico.</DescriptionContent>
                
            <ContentStyled>
                <ChipStyled label={<CapitalizeWord>{category}</CapitalizeWord>} color='base' />
                <ChipStyled label={`${quantity} quesiti`} color='base'/>
                <ChipStyled label={
                <>                                  
                    {level===LEVELNAME.ELEMENTARY && <WrapperStars><IconStar /><IconStarOutline/><IconStarOutline/></WrapperStars>}
                    {level===LEVELNAME.MEDIUM && <WrapperStars><IconStar/><IconStar/><IconStarOutline/></WrapperStars>}
                    {level===LEVELNAME.HARD && <WrapperStars><IconStar/><IconStar/><IconStar /></WrapperStars>}
                    {level === LEVELNAME.STANDARD && <CapitalizeWord>mix</CapitalizeWord>}
                </>
                }
                color='base'
                     />
                <ChipStyled label={timer? `${timer} minuti`: 'Timer off'} color='base'/>      
            </ContentStyled>

            <WrapperActions >
                {/* <ButtonStyled component={Link} to={`/custom/${idQuiz}`} variant="contained" color='benjamin'>vai al quiz</ButtonStyled>   */}
                <ButtonStyled component={Link} to={`/${idFastQuiz? `fastquiz/${idFastQuiz}`:`custom/${idQuiz}`}`} variant="contained" color='benjamin'>vai al quiz</ButtonStyled>    
                <ButtonStyled variant="outlined" color='benjamin' onClick={handleCopy}>{isCopied ? 'Link copiato' : 'Copia link'}</ButtonStyled>     
                {isAuthenticated && <ButtonStyled component={Link} to={pathNavigate} variant="outlined" color='benjamin' onClick={onClosePopup}>dashboard</ButtonStyled>}    
                <ButtonStyled variant="outlined" color='benjamin' onClick={onClosePopup}>indietro</ButtonStyled>                
            </WrapperActions>

            </Dialog>
            </>
    );
};